export default __webpack_public_path__ + "static/media/course_bg.118e79d5.svg";